import React from 'react';

import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

const BulkActions = ({
    selectedCount,
    itemName = 'item',
    deleting,
    onBulkDelete,
}) => {
    if (selectedCount > 0) {
        return (
            <Row className="mb-3">
                <Col>
                    <div className="bulk-actions-bar">
                        <div className="bulk-actions-info">
                            <span className="selected-count">
                                {selectedCount} {itemName}(s) selected
                            </span>
                        </div>
                        <div className="bulk-actions-buttons">
                            <Button
                                variant="danger"
                                size="sm"
                                disabled={deleting}
                                className="bulk-delete-btn"
                                onClick={onBulkDelete}
                            >
                                {deleting ? (
                                    <>
                                        Deleting...
                                    </>
                                ) : (
                                    <>
                                        Delete Selected
                                    </>
                                )}
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }

    return null;
};

BulkActions.propTypes = {
    selectedCount: PropTypes.number.isRequired,
    itemName: PropTypes.string,
    deleting: PropTypes.bool.isRequired,
    onBulkDelete: PropTypes.func.isRequired,
};

export default BulkActions;

